export default {
    information_please_choose: 'Please select ',
    information_please_fill_in: 'Please input ',
    organizer: "Organizer",
    fill_in_registration_information: "Fill in registration information",
    incorrect_phone_number: "Incorrect Phone Number",
    incorrect_email: "Incorrect Email",
    please_contact_the_organizer: "The information submitted will not be changed. If you need to change it, please contact the organizer.",
    submit: "Submit",
    country: "country",
    province: "province",
    cannot_be_modified: "The information has been submitted and cannot be modified",
    exhibitor_registration: "Apply Now",
    share: {
        interested: "Interested",
        likes: "Likes",
        time: "Time",
        enter: "Enter",
        pending: "Pending",
        live: "Live",
        playback: 'Playback',
        finish: "Ended",
        introduction: "Live Information",
        exhibits: "Exhibitors Details",
        seen: "Seen",
        looking: "Seen" // Looking

    },
    comingSoon: "Coming Soon",
    comingSoonTitel: "Coming Soon",
    cancel: "Cancel",
    confirm: "Confirm",
    layoutOfHall: 'Layout of exhibition hall',
    floorplan: 'Floorplan',
    trafficMap: 'Traffic map',
    meetNums: "Conference number",
    meetChair: 'Chair of the meeting',
    meetJoinPeople: "attendee",
    invited: "Invited",
    people: "people",
    meetStatus: {
        accepted: "Accepted",
        noResponse: "No response",
        rejected: "Rejected"
    }
}